export type ValueOf<T> = T[keyof T];

export type UnionToIntersection<U> = (
  U extends any ? (k: U) => void : never
) extends (k: infer I) => void
  ? I
  : never;

export const isStringsArray = (array: any): array is string[] => {
  return (
    Array.isArray(array) && (array.length === 0 || typeof array[0] === "string")
  );
};

export const isSymbol = (value: any): value is symbol =>
  typeof value === "symbol";
